module.exports = __webpack_public_path__ + "static/product-bigbarters-ecommerce-662143f401f13e118307f83e7c0d90b3.png";